module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector",
    style: ({
      background: _vm.enabled === false && 'none'
    })
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": _vm.onclickPanel
    }
  }, [_c('span', {
    staticClass: "color-block"
  }, [_c('div', {
    staticClass: "color-block-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "color-block-cell",
    style: ({
      backgroundColor: _vm.hexColor
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "color-label"
  }, [_vm._v(_vm._s(_vm.colorLabel))]), _vm._v(" "), (_vm.enabled !== false) ? _c('span', {
    staticClass: "color-drop"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.colorPanelVisible),
      expression: "colorPanelVisible"
    }],
    ref: "colorpicker_wrapper",
    staticClass: "wrapper",
    on: {
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onmousedownWrapper($event)
      }
    }
  }), _vm._v(" "), _c('sketch-color', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.colorPanelVisible),
      expression: "colorPanelVisible"
    }],
    ref: "colorpicker",
    staticClass: "wrapper-color",
    attrs: {
      "value": _vm.colorObject
    },
    on: {
      "input": _vm.onColorChanged
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1cb026","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-ctrls/colorbox.vue
// module id = 71
// module chunks = 2